import React from "react";

import Loading from "../../../../intelws_portal/constructs/elements/Loading";

import Tabs, { ITabRepr } from "../../../../intelws_portal/constructs/elements/Tabs";

import ClientDashboard from "../../common/clientDashboard/Dashboard/ClientDashboard";
import ClientCommunication from "../../common/clientDashboard/ClientCommunication";
import ClientDocuments from "../../common/clientDashboard/ClientDocument";
import ClientStatus from "../../common/clientDashboard/ClientStatus";
import ClientBusiness from "../../common/clientDashboard/ClientBusiness";
import ClientOrganizer from "../../common/clientDashboard/ClientOrganizer";
import ClientCard from "../../common/clientDashboard/Dashboard/ClientCard";
import ClientInvoice from "./ClientInvoice";
import ClientProject from "./ClientProject";
import ContentBox from "../../../../intelws_portal/constructs/elements/ContentBox";
import { IPageComponentProps } from "../../../../declarations/common";
import { IDataRepr } from "../../../../intelws_portal/constructs/elements/Table";
import { IMenuOptionsConfig } from "../../../App";
import ClientDependent from "./ClientDependent";
import { get, getCancelToken } from "../../../../intelws_portal/utils/backendInterface";
import { AxiosResponse } from "axios";
import { request } from "http";
import ClientForm from "./ClientForm";

interface IMatchProps {
    userId: string
}

interface IFetchIsLead extends AxiosResponse {
    data: {
        is_lead: boolean
    }
}

export interface IClientDashboardLanding<T> extends IPageComponentProps<T> {
    mutator: {
        currentPage?: (currentPage: string) => void,
        getMenuOptionsConfig: () => IMenuOptionsConfig
    },
}


function ClientDashboardLanding(props: IClientDashboardLanding<IMatchProps>) {
    const userId = parseInt(props.match.params.userId);

    const cancelToken = React.useRef(getCancelToken());

    const [bnsValues, setBnsValues] = React.useState<number[]>([]);
    const [bnsShow, setBnsShow] = React.useState<string[]>([]);
    const [clientContent, setClientContent] = React.useState<(string | undefined)[]>(() => {
        let clientContent = new Array(props.mutator.getMenuOptionsConfig().client_dashboard?.length).fill(undefined);
        clientContent[0] = (props.mutator.getMenuOptionsConfig().client_dashboard as ITabRepr[])[0].target;
        return clientContent;
    });
    const [clientTabs, setClientTabs] = React.useState<ITabRepr[]>(props.mutator.getMenuOptionsConfig().client_dashboard as ITabRepr[]);

    const [isLead, setIsLead] = React.useState(false);

    const [isLoading, setIsLoading] = React.useState(true);

    React.useEffect(() => {
        const ENDPOINT = "/api/leads/";
        const queryParams = {
            section: "get_is_lead",
            user_id: userId.toString()
        };
        const requestResponse = get(ENDPOINT, cancelToken.current.token, queryParams) as Promise<IFetchIsLead>

        requestResponse.then((response) => {
            setIsLead(response.data.is_lead);
            if (response.data.is_lead) {
                setClientTabs(props.mutator.getMenuOptionsConfig().lead_dashboard as ITabRepr[]);
                setClientContent((prevClientContent) => {
                    let clientContent = new Array(props.mutator.getMenuOptionsConfig().lead_dashboard?.length).fill(undefined);
                    clientContent[0] = (props.mutator.getMenuOptionsConfig().lead_dashboard as ITabRepr[])[0].target;
                    return clientContent;
                })
            } else {
                setClientTabs(props.mutator.getMenuOptionsConfig().client_dashboard as ITabRepr[]);
                setClientContent((prevClientContent) => {
                    let clientContent = new Array(props.mutator.getMenuOptionsConfig().client_dashboard?.length).fill(undefined);
                    clientContent[0] = (props.mutator.getMenuOptionsConfig().client_dashboard as ITabRepr[])[0].target;
                    return clientContent;
                })
            }
            setIsLoading(false);
        })
    }, []);

    function resolveTargetToComponent(target?: string) {
        if (target == "clientDashboardTabContent") {
            return <ClientDashboard match={props.match} history={props.history} location={props.location} mutator={props.mutator} isLead={isLead} />;
        } else if (target == "clientCommunicationTabContent") {
            return <ClientCommunication match={props.match} history={props.history} location={props.location}
                mutator={{ getMenuOptionsConfig: props.mutator.getMenuOptionsConfig }} />;
        } else if (target == "clientDocumentTabContent") {
            return <ClientDocuments match={props.match} mutator={{ bnsDocCallback: bnsDocCallback }}
                bnsValues={bnsValues} bnsShow={bnsShow} history={props.history} location={props.location} />;
        } else if (target == "clientStatusTabContent") {
            return <ClientStatus match={props.match} history={props.history} location={props.location} />;
        } else if (target == "clientBusinessTabContent") {
            return <ClientBusiness match={props.match} mutator={{ bnsOperCallback: bnsOperCallback, getMenuOptionsConfig: props.mutator.getMenuOptionsConfig }}
                history={props.history} location={props.location} />;
        } else if (target == "clientOrganizerTabContent") {
            return <ClientOrganizer match={props.match} history={props.history} location={props.location} />;
        } else if (target == "clientInvoiceTabContent") {
            return <ClientInvoice match={props.match} history={props.history} location={props.location} />
        } else if (target == "clientProjectsTabContent") {
            return <ClientProject match={props.match} mutator={{ bnsDocCallback: bnsDocCallback }}
                bnsValues={bnsValues} bnsShow={bnsShow} history={props.history} location={props.location} />;
        } else if (target == "clientDependentTabContent") {
            return <ClientDependent match={props.match} history={props.history} location={props.location} />
        } else if (target == "clientFormsTabContent") {
            return <ClientForm match={props.match} history={props.history} location={props.location}
                    mutator={{ getMenuOptionsConfig: props.mutator.getMenuOptionsConfig }} />
        }
        
        return <Loading />
    }

    function bnsDocCallback(bnsData: IDataRepr[]) {
        let bnsShow = ["Select Business"];
        let bnsValues = [0];
        bnsData.forEach((ele) => {
            bnsShow.push(ele.bns_name as string);
            bnsValues.push(ele.id);
        })
        setBnsShow(bnsShow);
        setBnsValues(bnsValues);
    }

    function bnsOperCallback(bns: IDataRepr, oper: string) {
        setBnsValues((prevBnsValues) => {
            return [...prevBnsValues, bns.id];
        })
        setBnsShow((prevBnsShow) => {
            return [...prevBnsShow, bns.bns_name as string];
        })
    }



    function getContent() {
        if (isLoading) {
            return <Loading />
        }

        let contents: { content: JSX.Element }[] = [];
        clientContent.forEach((ele) => {
            contents.push({ content: resolveTargetToComponent(ele) });
        })
        return (
            <Tabs center={true} tabs={clientTabs} contents={contents}
                tabCallback={(tabName, index) => {
                    setClientContent((prevClientContent) => {
                        let newClientContent = [...prevClientContent];
                        newClientContent[index] = clientTabs[index].target;
                        return newClientContent;
                    })
                }} />
        )
    }

    function aggregrateContent() {
        if (props.mutator.getMenuOptionsConfig().client_card) {
            return (
                <div>
                    <ClientCard userId={userId} clientContext={false} isLead={isLead} />
                    {getContent()}
                </div>
            )
        } else {
            return (
                <div>
                    {getContent()}
                </div>
            )
        }

    }

    return (
        <div className="body-content-wrapper">
            <ContentBox body={aggregrateContent()} />
        </div>
    )
}

export default ClientDashboardLanding

